import { render, staticRenderFns } from "./SubTaskSetMaster.vue?vue&type=template&id=5907218b&scoped=true&"
import script from "./SubTaskSetMaster.vue?vue&type=script&lang=js&"
export * from "./SubTaskSetMaster.vue?vue&type=script&lang=js&"
import style0 from "./SubTaskSetMaster.vue?vue&type=style&index=0&id=5907218b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5907218b",
  null
  
)

export default component.exports